"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2007-2023 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var InsightDateDataSetFilter_1 = tslib_1.__importDefault(require("./InsightDateDataSetFilter"));
var sdk_model_1 = require("@gooddata/sdk-model");
var AttributeFilterConfiguration_1 = require("../../common/configuration/AttributeFilterConfiguration");
function InsightFilters(_a) {
    var widget = _a.widget;
    return (react_1.default.createElement("div", { className: "s-viz-filters-panel configuration-category" },
        react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "h3", className: "s-viz-filters-headline" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "configurationPanel.filterBy" })),
        sdk_model_1.isInsightWidget(widget) ? react_1.default.createElement(InsightDateDataSetFilter_1.default, { widget: widget }) : null,
        react_1.default.createElement(AttributeFilterConfiguration_1.AttributeFilterConfiguration, { widget: widget })));
}
exports.default = InsightFilters;
//# sourceMappingURL=InsightFilters.js.map